import {IMultiOccurrenceOptions} from '../../../../../core/services/multi-occurrence.service';

interface IPageIn1000 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}
/* @ngInject */
export default function In1000Controller() 
{
    const vm: IPageIn1000 = this;

    vm.multiOccurrenceOptions = {
        fonctions:{
            rechercheCollapsable:false
        },
        colonnesFixesGauche:[
            {nom: 'procod', largeur: 200},
            {nom: 'prodsc', largeur: 300}
        ],
        colonnesVisibles: [
            {nom: 'magcod', largeur: 150},
            {nom: 'magnom', largeur: 300},
            {nom: 'malcod', largeur: 150},
            {nom: 'tmodsc', largeur: 200},
            {nom: 'triqte', largeur: 150},
        ]

    };
}
